import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import DragItem from "../drag-item";

const FileListItem = ({ itemObject, index }) => {
  const theme = useTheme();
  const { setNodeRef, isOver } = useDroppable({
    id: itemObject.id,
    data: { type: "file-slot", index }
  });
  const isMapped = Boolean(itemObject.token);
  const isDark = theme.palette.mode === "dark";
  const textColor = isDark ? "#fff" : "#000";
  const filledGreen = isDark ? alpha("#7dcea0", 0.28) : "#e7f7ee";
  const filledBorder = isDark ? alpha("#9ed9b6", 0.85) : "#8dcea8";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.5 }}>
      <Typography
        variant="body2"
        noWrap
        title={itemObject.columnName || "(empty)"}
        sx={{ width: "42%", color: itemObject.columnName ? textColor : "text.disabled" }}
      >
        {itemObject.columnName || "(empty)"}
      </Typography>
      <Box
        ref={setNodeRef}
        data-testid={`import-file-slot-${index}`}
        sx={{
          flex: 1,
          minHeight: 32,
          display: "flex",
          alignItems: "center",
          px: 0.75,
          borderRadius: 1,
          border: 1,
          borderStyle: isMapped ? "solid" : "dashed",
          borderColor: isOver || isMapped ? filledBorder : "divider",
          bgcolor: isOver ? alpha("#7dcea0", isDark ? 0.42 : 0.45) : isMapped ? filledGreen : "transparent",
          color: textColor
        }}
      >
        {isMapped ? (
          <DragItem token={itemObject.token} />
        ) : (
          <Typography variant="caption" color="text.disabled">
            Drop column
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FileListItem;
